module.exports = __webpack_public_path__ + "img/empty.e849a87b.png";